export default "__VITE_ASSET__DAhlVcAh__"